import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "../store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import {Util} from "@/_global/utils";
import ThemesStore from "@/store/modules/ThemesStore";

@Module({
    name: "ThemeVariableStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class ThemeVariableStore extends VuexModule {
    // state
    private _apiResponse: CMS.ThemeVariable = {} as CMS.ThemeVariable;

    private apiBackup: CMS.ThemeVariable = {} as CMS.ThemeVariable;
    private _dirty: boolean = false;

    // getter
    get all(): CMS.ThemeVariable {
        return this._apiResponse || {};
    }

    get dirty(): boolean {
        return this._dirty;
    }

    @Action
    public async init(param: { themeId: number, menuId: number }) {
        const response: CMS.ThemeVariable = await CmsApiClient.getThemeVariable(param.themeId, param.menuId);

        if (Object.keys(response).length > 0) {
            // データがあればそのまま保持
            this.refresh(response);
        } else {
            // データがなければひな型で初期化
            const themeOption: CMS.ThemeOption = ThemesStore.themeById[param.themeId].theme_options;

            const pagesValue: any = {};
            for (let i = 0; i < themeOption.pages.length; i++) {
                pagesValue[themeOption.pages[i].name] = {}
            }

            const themeOptionTemplate: CMS.ThemeVariable = {
                theme_id: param.themeId,
                menu_id: param.menuId,
                value: {
                    languages: themeOption.languages,
                    pages: themeOption.pages.reduce((result: any, page) => Object.assign(result, {[page.name]: {}}), {}) // <-- { standby:{}, categories:{}, items:{} } みたいなデータにする
                }
            };

            this.refresh(themeOptionTemplate);
        }
    }

    @Action
    private refresh(response: CMS.ThemeVariable) {
        this.initVals();
        this.setResponse(response);
    }

    @Mutation
    private initVals(): void {
        this._apiResponse = {} as CMS.ThemeVariable;
        this._dirty = false;
    }

    @Mutation
    private setResponse(response: CMS.ThemeVariable) {
        this._apiResponse = response;
        this.apiBackup = Util.deepCopy(this._apiResponse); //復元用にdeep copyでバックアップ
    }

    @Mutation
    public localEdit(param: { page: string, option: string, value: string }) {
        Vue.set(this._apiResponse.value.pages[param.page], param.option, param.value);
        this._dirty = true;
    }

    @Action
    public async cancelEdit() {
        this.refresh(this.apiBackup);
    }

    @Action
    public async applyEdit() {
        if (!this.dirty)
            return;

        await CmsApiClient.setThemeVariable(this._apiResponse);
        this.init({themeId: this._apiResponse.theme_id, menuId: this._apiResponse.menu_id});
    }

    @Action
    public async copy(newMenuId: number) {
        this._apiResponse.menu_id = newMenuId;
        await CmsApiClient.setThemeVariable(this._apiResponse);
        this.init({themeId: this._apiResponse.theme_id, menuId: this._apiResponse.menu_id});
    }


}

export default getModule(ThemeVariableStore);
